import React from "react";
import { Link } from "react-router-dom";
import "./undergraduates.scss";
import Image4 from "../../assets/images/c3.webp";
import Image5 from "../../assets/images/graduate.png";
import Image6 from "../../assets/images/applied.webp";
import Image7 from "../../assets/images/ms.jpeg";
import Table from "react-bootstrap/Table";
import Image1 from "../../assets/images/cap.webp";
export const Undergraduates = () => {
  return (
    <>
      <div className="undergraduates-page">
        <center>
          <h1>Prospective Undergraduates</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Studying physics</h6>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 flexy mt">
        <div className="col-md-6">
          <p>
            Physics at undergraduate level is offered through the Natural
            Sciences Tripos (NST) in conjunction with other physical and
            biological sciences, and allows specialisation to occur as the
            students progress through the Tripos. The course finishes with
            complete physics degrees on Bachelor or Masters level that are
            accredited by the Institute for Physics. For details on how to apply
            please see the relevant Natural Sciences Tripos and central pages.
          </p>
          <p>
            For undergraduate study, it is not possible to apply directly to the
            Department of Physics, although many of the staff of the Department
            will be involved in the admissions process via their colleges.
            Further information on the course can be found in the page for
            Current Undergraduates.
          </p>
        </div>
        <div className="col-md-6">
          <img className="" src={Image4} alt="Scholar" width="100%" />
        </div>
      </div>
      <center>
        {" "}
        <div className="col-md-6 mtt">
          <h2> CAREER OPPORTUNITIES FOR A PHYSICS GRADUATE</h2>
          <p>
            It is generally believed in this part of the world that any graduate
            of Physics will ultimately end up in the Classroom as a Teacher. It
            has to be stated in clear terms here that this is far from the
            truth. Indeed, any graduate of Physics has vast opportunities in
            almost every facet of human endeavour. The table below shows a list
            of areas in which a Physics graduate can make a career.
          </p>
        </div>
      </center>

      <div className="col-md-8 mt offset-md-2">
        <div className="flexy">
          <div className="col-md-6 mtt">
            {" "}
            <img className="" src={Image5} alt="Scholar" width="95%" />
          </div>
          <div className="col-md-6">
            {" "}
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Areas of Choice</th>
                  <th>Employment Opportunities</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Education</td>
                  <td>
                    Employment as a Teacher in Secondary and Primary Schools.
                    Academic staff in Universities. Research Assistants in
                    Universities. Technologists Employment as a non-teaching
                    staff in Universities
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Armed Services</td>
                  <td>Army, Air force, Navy Research Units</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Paramilitary</td>
                  <td>
                    Road Safety Corps Customs Civil Defence Corps Immigration
                  </td>
                </tr>{" "}
                <tr>
                  <td>4</td>
                  <td>Civil Service</td>
                  <td>All aspects of the Civil Service</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Public Service/Corporations</td>
                  <td>
                    Oil and gas Companies Vehicle Manufacturing Electrical
                    Companies Electronics/Semiconductor Companies
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Entertainment</td>
                  <td>Sound Engineer</td>
                </tr>{" "}
                <tr>
                  <td>7</td>
                  <td>Parastatals</td>
                  <td>
                    Atomic Energy Research Centres Nuclear Regulatory Agency
                    Space Research Centres Electricity Regulatory Agency, etc.
                  </td>
                </tr>{" "}
                <tr>
                  <td>8</td>
                  <td>Information Technology</td>
                  <td>Telecommunication Companies Software Developers Banks</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <p className="mt6">
          The career opportunities open to a Physics graduate is quite
          inexhaustible and the list shown in Table 1 is just but a few to whet
          your appetite. A graduate of Physics, majoring in{" "}
          <strong>Applied Geophysics</strong>, has several areas available to
          pursue as his or her career. Some of these areas are as listed below:
        </p>
        <div className="flexy mt4">
          <div className="col-md-6 career-list2">
            <ol>
              <li>
                Civil Service Sector: Government Ministries and Parastatals:
                <ul>
                  <li> Federal Ministry of Science and Technology</li>
                  <li> Nigeria Geological Survey</li>
                  <li> River Basin Authorities</li>
                  <li> Ministries of Environment and Town Planning.</li>
                </ul>
              </li>
              <li>
                Public Sector:
                <ul>
                  <li>Petroleum Industries (in exploration)</li>
                  <li> Construction Industries</li>
                  <li>Research Institutes and Centres</li>
                  <li>
                    {" "}
                    Universities and Polytechnics for Research and Teaching.
                  </li>
                </ul>
              </li>{" "}
              <li>
                Private Sector:
                <ul>
                  <li>
                    Consultancy Agencies involved in Groundwater Investigation;
                    Environmental Studies and Mineral Exploration.
                  </li>
                  <li> Personal Consultancy Outfit.</li>
                </ul>
              </li>
            </ol>
          </div>
          <div className="col-md-6">
            <img className="" src={Image6} alt="Scholar" width="100%" />
          </div>
        </div>
        <p className="mt6">
          A graduate of Physics, majoring in <strong>Material science</strong>,
          has several areas available to pursue as his or her career. Some of
          these areas are as listed below:
        </p>
        <div className="flexy">
          <div className="col-md-6 mt6 career-list">
            <ul>
              <li>
                In Electrical/Electronics Industry as a Materials Innovator and
                Developer of new improved materials
              </li>
              <li>
                As procurement officer for Engineering and Fabrication
                Industries.
              </li>
              <li>
                In Metallurgical, Thin film, Solar Energy, Nanotechnology and
                Nanomaterials, Plastics, Wood, Paints, Adhesives, Cement,
                Ceramics Industries amongst others like Materials Testing and
                Certification Officer.
              </li>
              <li>
                As Construction and Inspection officer in Structural, Civil and
                Construction Engineering Firms that build Houses, Bridges, etc.
              </li>
              <li>
                As Procurement Officer and Materials Inspection Personnel in
                Corrosion Control in Industries.
              </li>
              <li>
                In Teaching and Research at the University and other Research
                Institutes, to pass on knowledge thereby impacting innovative
                spirit to young talented and gifted individuals who will in turn
                make an impact in their world.
              </li>
            </ul>
          </div>
          <div className="col-md-6 mt7">
            {" "}
            <img className="" src={Image7} alt="Scholar" width="100%" />
          </div>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mtt">
        {" "}
        <center>
          <h1 className="">ADMISSION REQUIREMENTS</h1>
          <div className="flexy flexyM col-md-2 ">
            {" "}
            <div className="bbb ">&nbsp;</div>
            <img className="" src={Image1} alt="Scholar" width="20%" />
            <div className="bbb ">&nbsp;</div>
          </div>
        </center>
        <div className="col-md-6 mt6 career-list offset-md-3">
          <p>
            The minimum entry requirement for admission to the Bachelor’s degree
            programme in the Department of Physics, University of Port Harcourt
            in accordance with the minimum academic standard of the National
            University Commission (NUC) is
            <strong> five (5) credits passes</strong> at not more than two
            sittings in the West African School Certificate (WASC), or Senior
            School Certificate Examination (SSCE) or (NECO) or NABTECH
            examination. The credits must include{" "}
            <strong>English Language</strong>, <strong>Mathematics</strong>,
            <strong> Physics</strong>, <strong>Chemistry</strong> and{" "}
            <strong>Biology</strong> or<strong> Agricultural Science</strong>.
          </p>
          <p>
            The candidate can also be admitted into 200 level through the direct
            entry programme. The admission requirement for this category is as
            stated below:
          </p>
          <h5>DIRECT ENTRY</h5>
          <ul>
            <li>
              <strong>Two A/level GCE</strong> or <strong>HSC </strong>passes in
              Physics and any one of Mathematics or Chemistry (with a minimum of
              ‘C’ which is 3 points each to a cumulative total of 10 points)
              including UTME requirement.
            </li>
            <li>
              <strong>Two A/level JPEB</strong> passes in Physics and any one of
              Mathematics or Chemistry including UTME requirement.
            </li>
            <li>
              <strong>OND</strong> or <strong>ND</strong> in Physics with upper
              credit from a recognized Institutions including UTME requirement.
            </li>
            <li>
              <strong>HND</strong> in Physics with lower credit from a
              recognized institution including UTME.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
